import { render } from "./ServicesItsCarouselComp.vue?vue&type=template&id=662315d8&scoped=true"
import script from "./ServicesItsCarouselComp.vue?vue&type=script&lang=js"
export * from "./ServicesItsCarouselComp.vue?vue&type=script&lang=js"

import "./ServicesItsCarouselComp.vue?vue&type=style&index=0&id=662315d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662315d8"]])

export default __exports__